module.exports = __webpack_public_path__ + "img/hr-H-B-1-unload-standup-shadow.56c08f04.png";